import { faqItem } from '@/types/faqs.types';

export const faqData: faqItem[] = [
  {
    question: 'What makes JobAssure different from other job boards?',
    answer:
      "We've eliminated the noise. By sourcing jobs directly from company career sites and aggregating genuine jobs, you now have a single source of truth for your job search. No more sifting through irrelevant job postings on multiple job boards. With JobAssure, you can focus on finding the perfect job, not fighting through mediocre job listings.",
  },
  {
    question: 'How do you ensure job quality?',
    answer:
      "We take pride in hand-picking companies that truly care about their employees, offering a positive work environment, competitive salaries, and a clear path for growth. By choosing us, you're choosing a better future for yourself.",
  },
  {
    question: 'Will I waste my time applying for expired jobs?',
    answer:
      "No, we update our job listings near to real time to ensure you have access to the most current opportunities across premium invite-only job boards, so you can avoid the frustration of applying for expired jobs.",
      // We also verify the job postings to ensure they are legitimate and active.
  },
  {
    question: 'How JobAssure AI can enhance &  speed up my job search?',
    answer:
      "With JobAssure AI, you can find jobs faster by analyzing your resume and matching it with relevant job postings and GenAI resume enhancements everything at once while you are searching. It can also provide personalized job recommendations based on your preferences. Stop wasting your time and energy searching for the right job, get the job that you deserve with JobAssure AI. ",
  },
  // {
  //   question: 'How do I apply for jobs?',
  //   answer:
  //     "Once logged in, search for jobs using keywords or filters. Click on the job title and hit the 'Apply' button, then follow the application instructions.",
  // },
  {
    question: 'Can I save jobs to apply for later?',
    answer:
      "Yes, click the 'Save Job' button on the job listing to save it. You can find saved jobs in your dashboard under 'Saved Jobs.'",
  },
  {
    question: 'Can I receive job alerts?',
    answer:
      "Yes, set up job alerts by going to 'Job Alerts' in your account, specifying your preferences, and you’ll receive relevant job notifications via email.",
  },
  {
    question: 'Is there a fee to use this job portal?',
    answer:
      'No, using the job portal to search and apply for jobs is completely free for job seekers.',
  },
  {
    question: 'Can I delete my account?',
    answer:
      "Yes, go to 'Account Settings' and select 'Delete Account.' Please note that this action is permanent.",
  },
  // {
  //   question: 'How do I create an account?',
  //   answer:
  //     "Click the 'Sign Up' button on the homepage, fill in your details, and follow the instructions to verify your email.",
  // },
];
